import parentView from "@/components/parent-view";
import quyu from "./quyu.png";
export default [
  {
    path: "/deviceman/downloadlist",
    name: "downloadlist",
    icon: "icon-peixiazai",
    meta: {
      title: "下载记录",
      notCache: true,
      icon: "icon-peixiazai", // 使用自定义图标
      hideInMenu: true
    },
    component: () => import("@/view/download/download.vue")
  },

  {
    path: "/dailishang",
    name: "jingxiaoshang",
    icon: "icon-peia-generaluser-group",
    meta: {
      title: "代理商管理",
      notCache: true,
      icon: "icon-peia-generaluser-group"
    },
    component: parentView,
    children: [
      {
        path: "/jingxiaoshang",
        name: "jingxiaoshang",
        meta: {
          title: "代理商管理",
          notCache: true
        },
        component: () =>
          import("@/view/console/jingxiaoshang/jingxiaoshang.vue")
      },
      {
        path: "/area",
        name: "area",
        meta: {
          title: "区域管理",
          notCache: true
        },
        component: () => import("@/view/console/areaClass/areaClass.vue")
      },
      {
        path: "/auth/role",
        name: "role",
        icon: "md-person-add",
        meta: {
          title: "角色管理",
          icon: "md-person-add",
          notCache: true
        },
        component: () => import("@/view/page/authManage/role/role.vue")
      },

    ]
  },
          {
        path: "/user",
        name: "用户管理",
        icon: "icon-peia-generaluser-group",
        meta: {
          title: "用户管理",
          icon: "icon-peia-generaluser-group",
          notCache: true
        },
        component: () => import("@/view/page/authManage/user/user.vue")
      },
  {
    path: "/shengchan",
    name: "生产管理",
    icon: "icon-peia-Frame21",
    meta: {
      title: "生产管理",
      notCache: true,
      icon: "icon-peia-Frame21"
    },
    component: () => import("@/view/console/shengchan/shengchan.vue")
  },

  {
    path: "/out",
    name: "出库管理",
    icon: "icon-peia-Frame21",
    meta: {
      title: "出库管理",
      notCache: true,
      icon: "icon-peia-Frame21"
    },
    component: () => import("@/view/console/outbound/outbound.vue")
  },
  {
    path: "/download",
    name: "资料下载",
    icon: "icon-peia-Frame3",
    meta: {
      title: "资料下载",
      notCache: true,
      icon: "icon-peia-Frame3"
    },
    component: () => import("@/view/console/datadownload/datadownload.vue")
  },
  {
    path: "/deviceman",
    name: "deviceman",
    icon: "icon-peiFrame",
    meta: {
      title: "设备管理",
      notCache: true
      // icon: 'icon-peiFrame',
    },
    component: parentView,
    children: [
      // {
      //   path: '/deviceman/product',
      //   name: 'product',
      //   icon: 'ios-apps',
      //   meta: {
      //     title: '产品',
      //     notCache: true,
      //     icon: 'ios-apps'
      //   },
      //   component: () => import('@/view/console/deviceman/product/product.vue'),
      // },
      {
        path: "/deviceman/devicedistribution",
        name: "devicedistribution",
        icon: "",
        meta: {
          title: "设备列表",
          notCache: true,
          icon: ""
        }, ///view/console/area/floor/floor.vue
        component: () =>
          import("@/view/console/deviceman/devicedistribution/devicedistribution.vue")
      },
      {
        path: "/deviceman/piliang",
        name: "批量设置",
        icon: "",
        meta: {
          title: "批量设置",
          notCache: true,
          icon: ""
        }, ///view/console/area/floor/floor.vue
        component: () =>
          import("@/view/console/deviceman/devicedistribution/batchSettings.vue")
      },
      {
        path: "/deviceman/distributionLog",
        name: "distributionLog",
        icon: "ios-apps",
        meta: {
          title: "历史记录",
          notCache: true,
          icon: "ios-apps"
          //hideInMenu:true
        },
        component: () =>
          import("@/view/console/deviceman/devicedistribution/distributionLog.vue")
      },
      {
        path: "/deviceman/control",
        name: "control",
        icon: "ios-apps",
        meta: {
          title: "控制",
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () => import("@/view/console/deviceman/control/control.vue")
      },
      {
        path: "/deviceman/detailsNew",
        name: "detailsNew",
        icon: "ios-apps",
        meta: {
          title: "查看", //高压
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/deviceman/details/detailsNew.vue")
      },

      {
        path: "/deviceman/details",
        name: "details",
        icon: "ios-apps",
        meta: {
          title: "查看", //高压
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () => import("@/view/console/deviceman/details/details.vue")
      },
      {
        path: "/deviceman/details2",
        name: "details",
        icon: "ios-apps",
        meta: {
          title: "查看", //高压
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () => import("@/view/console/deviceman/details/details2.vue")
      },
        {
    path: "/infodata",
    name: "消息",
    icon: "ios-apps",
    meta: {
      title: "查看", //高压
      notCache: true,
      icon: "ios-apps",
      hideInMenu: true
    },
    component: () => import("@/view/console/infoData/infodata.vue")
  },
   {
        path: "/deviceman/piliang/batchSettingsList",
        name: "details",
        icon: "ios-apps",
        meta: {
          title: "设置设备", //低压
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/deviceman/devicedistribution/batchSettingsList.vue")
      },
   {
        path: "/deviceman/detailsdy",
        name: "details",
        icon: "ios-apps",
        meta: {
          title: "查看", //低压
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/deviceman/details/detailsdy.vue")
      },
      {
        path: "/deviceman/detailsdy",
        name: "details",
        icon: "ios-apps",
        meta: {
          title: "查看", //低压
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/deviceman/details/detailsdy.vue")
      },
      {
        path: "/deviceman/detailscc",
        name: "details",
        icon: "ios-apps",
        meta: {
          title: "查看", //叉车
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/deviceman/details/detailscc.vue")
      },
      {
        path: "/deviceman/detailsNbc",
        name: "details",
        icon: "ios-apps",
        meta: {
          title: "查看", //高压
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/deviceman/details/detailsNbc.vue")
      },
 {
        path: "/deviceman/detailsSCLI",
        name: "details",
        icon: "ios-apps",
        meta: {
          title: "查看", //高压
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/deviceman/details/detailsSCLI.vue")
      },
      {
        path: "/deviceman/detailsdy2",
        name: "details",
        icon: "ios-apps",
        meta: {
          title: "查看", //低压
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/deviceman/details/detailsdy2.vue")
      },
      {
        path: "/deviceman/trajectory",
        name: "trajectory",
        meta: {
          name: "trajectory",
          hideInMenu: false
        },
        component: () => import("@/view/single-page/trajectory/trajectory.vue")
      },
      {
        path: "/trajectory",
        name: "/trajectory",
        meta: {
          name: "trajectory",
          hideInMenu: true
        },
        component: () => import("@/view/single-page/trajectory/trajectory.vue")
      },
      {
        path: "/trajectoryManage/trajectory",
        name: "details",
        icon: "ios-apps",
        meta: {
          title: "设备轨迹",
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/trajectoryManage/trajectory/trajectory.vue")
      }
      //  {
      //   path: '/protocolman/projectprotocollist',
      //   name: 'projectprotocollist',
      //   icon: 'ios-apps',
      //   meta: {
      //     title: '自定义协议',
      //     notCache: true,
      //     icon: 'ios-apps',
      //     hideInMenu:true
      //   },
      //   component: () => import('@/view/console/protocolman/projectprotocollist/protocollist.vue'),
      //  },
      //  {
      //   path: '/protocolman/projectprotocollist2',
      //   name: 'projectprotocollist',
      //   icon: 'ios-apps',
      //   meta: {
      //     title: '自定义协议',
      //     notCache: true,
      //     icon: 'ios-apps',
      //     hideInMenu:true
      //   },
      //   component: () => import('@/view/console/protocolman/projectprotocollist2/protocollist.vue'),
      // },
    ]
  },

  {
    path: "/alarmManage",
    name: "alarmManage",
    icon: "icon-peiexclamation-circle",
    meta: {
      title: "告警管理",
      notCache: true,
      icon: "icon-peiexclamation-circle"
    },
    component: parentView,
    children: [
      {
        path: "/alarmManage/alermDes",
        name: "alarmManage",
        meta: {
          title: "告警列表",
          notCache: true
        }, ///view/console/area/floor/floor.vue
        component: () =>
          import("@/view/console/alarmManage/alermDes/alermDes.vue")
      }
    ]
  },


  {
    path: "/protocolman",
    name: "protocolman",
    icon: "icon-peifile",
    meta: {
      title: "协议管理",
      icon: "icon-peifile"
    },
    component: parentView,
    children: [
      {
        path: "/protocolman/protocollist",
        name: "protocollist",
        icon: "",
        meta: {
          title: "协议管理",
          notCache: true,
          icon: ""
        },
        component: () =>
          import("@/view/console/protocolman/protocollist/protocollist.vue")
      },
      {
        path: "/protocolman/protocollist2",
        name: "protocollist2",
        icon: "ios-apps",
        meta: {
          title: "查看",
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/protocolman/protocollist2/protocollist.vue")
      }
    ]
  },
  {
    path: "/hardwareman",
    name: "hardwareman",
    icon: "icon-peiarchive",
    meta: {
      title: "硬件版本",
      icon: "icon-peiarchive"
    },
    component: parentView,
    children: [
      {
        path: "/hardwareman/hardwarelist",
        name: "hardwarelist",
        icon: "ios-podium",
        meta: {
          title: "硬件版本管理",
          notCache: true,
          icon: "ios-podium"
        },
        component: () =>
          import("@/view/console/hardwareman/hardwarelist/hardwarelist.vue")
      },
      {
        path: "/deviceman/product",
        name: "product",
        icon: "ios-apps",
        meta: {
          title: "产品",
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () => import("@/view/console/deviceman/product/product.vue")
      },
      {
        path: "/protocolman/projectprotocollist",
        name: "projectprotocollist",
        icon: "ios-apps",
        meta: {
          title: "自定义协议",
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/protocolman/projectprotocollist/protocollist.vue")
      },
      {
        path: "/protocolman/projectprotocollist2",
        name: "projectprotocollist",
        icon: "ios-apps",
        meta: {
          title: "自定义协议",
          notCache: true,
          icon: "ios-apps",
          hideInMenu: true
        },
        component: () =>
          import("@/view/console/protocolman/projectprotocollist2/protocollist.vue")
      }
    ]
  },
  {
    path: "/firmwareman",
    name: "firmwareman",
    icon: "icon-peia-Frame1",
    meta: {
      title: "固件管理",
      icon: "icon-peia-Frame1"
    },
    component: parentView,
    children: [
      {
        path: "/firmwareman/firmwarelist",
        name: "firmwarelist",
        meta: {
          title: "固件版本",
          notCache: true
        },
        component: () =>
          import("@/view/console/firmwareman/firmwarelist/firmwarelist.vue")
      },
      {
        path: "/firmwareman/uplist",
        name: "uplist",
        icon: "ios-podium",
        meta: {
          title: "升级规则",
          notCache: true,
          icon: "ios-podium",
          hideInMenu: true
        },
        component: () => import("@/view/console/firmwareman/uplist/uplist.vue")
      }
      // {
      //   path: '/protocolman/protocollist2',
      //   name: 'protocollist2',
      //   icon: 'ios-apps',
      //   meta: {
      //     title: '查看',
      //     notCache: true,
      //     icon: 'ios-apps',
      //     hideInMenu:true
      //   },
      //   component: () => import('@/view/console/protocolman/protocollist2/protocollist.vue'),
      // },
    ]
  },

  {
    path: "/auth",
    name: "auth",
    component: parentView,
    icon: "ios-lock",
    meta: {
      title: "权限管理",
      icon: "ios-lock"
    },
    children: [
      {
        path: "/auth/account",
        name: "account",
        icon: "ios-person",
        meta: {
          title: "帐号管理",
          icon: "ios-person",
          notCache: true
        },
        component: () => import("@/view/page/authManage/account/account.vue")
      },
      {
        path: "/auth/module",
        name: "moduleManage",
        icon: "ios-keypad-outline",
        meta: {
          title: "模块管理",
          icon: "ios-keypad-outline",
          notCache: true
        },
        component: () =>
          import("@/view/page/authManage/moduleManage/moduleManage.vue")
      },

      {
        path: "/auth/menu",
        name: "menu",
        icon: "ios-menu",
        meta: {
          title: "菜单管理",
          icon: "ios-menu",
          notCache: true
        },
        component: () => import("@/view/page/authManage/menu/menu.vue")
      },
      {
        path: "/auth/interface",
        name: "interface",
        icon: "ios-medical-outline",
        meta: {
          title: "接口管理",
          icon: "ios-medical-outline",
          notCache: true
        },
        component: () =>
          import("@/view/page/authManage/interface/interface.vue")
      }
    ]
  }
];
